export default __webpack_public_path__ + "static/media/bird_black_female.9ae4fea6.png";